import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import classes from "./Button.module.scss";
import { Link } from "react-router-dom";

const ECButton = React.forwardRef((props,ref) => {

  const useStyles = makeStyles({
    root: {
      textTransform: 'inherit',
      letterSpacing: 'inherit',
      fontSize: 'inherit',
      fontWeight: "bold",
      lineHeight: '17px',
      height: '40px',
      textAlign: 'center',
      padding: '0px 24px 0px 24px',
      ...props.style,
    }
  });

  const embeddedClasses = useStyles();
  return (
    <Button variant="contained" type={props.type || "button"} onClick={props.onClick} 
      disabled={props.disabled} startIcon={props.startIcon}
      className={`${classes[props.color || "primary"]} ${classes.basic} ${props.className} ${embeddedClasses.root} `}
      ref={ref}
    >
      {props.href ? <a href={props.href} className={classes.destination}>&nbsp;</a> : null} {props.to ? <Link to={props.to} className={classes.destination}></Link> : null}{props.children}
    </Button>
  );
});

export default ECButton;